import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import classNames from 'classnames'

type DropdownItemProps = {
  className?: string
  onClick: (e: Event) => void
  children: React.ReactNode
}

const DropdownItem = ({ className, onClick, children }: DropdownItemProps) => {
  return (
    <DropdownMenu.Item
      className={classNames(
        'group flex w-full items-center text-sm text-white rounded-[5px] px-[10px] py-[7px] outline-none cursor-default data-[highlighted]:bg-gray-700',
        className,
      )}
      onSelect={onClick}
    >
      {children}
    </DropdownMenu.Item>
  )
}

export default DropdownItem
